module.exports = __webpack_public_path__ + "img/wrapbg7.1b69af80.png";